
import {Component, Vue} from "vue-property-decorator";
import TamamlananGorevList from "@/components/lists/TamamlananGorevList.vue";
import DevamEdenGorevList from "@/components/lists/DevamEdenGorevList.vue";
import SorguOneriList from "@/components/lists/SorguOneriList.vue";
import SenkronRaporSeridi from "@/components/eicrapro/senkron/SenkronRaporSeridi.vue";
import TakipSenkronize from "@/plugins/uyap-plugin/takip_ac/TakipSenkronize";
import app from '@/main';

@Component({
  components:{DevamEdenGorevList, TamamlananGorevList, SorguOneriList, SenkronRaporSeridi}
})
export default class IslemlerView extends Vue {
  takipSenkronize : TakipSenkronize = new TakipSenkronize();
  loading : boolean = false;
  esas_no : string = "";

  async senkronize(){
    try{
      this.loading = true;
      await this.takipSenkronize.runQueryLastOneWeek();
      app.$toast.success("Takip Senkronizasyonu başarılı. Senkronize edilen takip sayısı : " + this.takipSenkronize.queueCount);
    }catch (e) {
      app.$toast.error("Takip Senkronizasyonu yapılamadı. Hata : " + e.message)
    }finally {
      this.loading = false;
    }

  }

  async uyariSenkronize(){
    try {
      let res =  await this.takipSenkronize.runQueryForSelectedItems([{
        dosya_esas_no : this.esas_no,
        birim_adi : ""
      }]);
      console.log("res");
    }catch (e) {
      console.log("eee",e);
    }
  }

  mounted() {
    this.$nextTick(() => {
      // Yumuşak tetikleyici: aynı kimlikle yakın zamanda devir yapıldıysa istek atılmaz.
      this.$store.dispatch('kimlikDevret', {neden: 'sayfa'});
      // Görev listesi eskiden eski oturum yoklamasının içinde, yalnız kart + UYAP oturumu varsa yükleniyordu;
      // artık imzacıdan bağımsız her açılışta yüklenir.
      this.$store.dispatch('updateTasks').catch(() => undefined);
    });
  }

  load() {
    if (!this.$store.getters.isImzaConnected)
      this.$store.dispatch("kimlikDevret", {neden: 'sayfa'});
  }
}
